import React from 'react';
import demoGif from '../media/bens-chat.gif';

const CliChatCratePage = () => {
  return (
    <div className="page-shell">
      <div className="page-shell__content section-stack">
        <section className="section-card center-text">
          <div className="eyebrow">Crates.io Registry</div>
          <h1 className="page-title">cli-chat (bens-chat-cli)</h1>
          <p className="page-copy" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            A fast, lightweight Command Line Interface (CLI) for receiving and sending messages from the Ben's Chat parent project without opening a web browser.
          </p>
        </section>

        <div className="section-stack">
          <section className="section-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.2rem' }}>
              <div>
                <div className="eyebrow">Crate</div>
                <h2 className="page-title" style={{ fontSize: '2.2rem', marginBottom: '0.25rem' }}>bens-chat-cli</h2>
                <p className="page-subtitle" style={{ fontSize: '1.05rem', margin: 0, maxWidth: '700px' }}>
                  Engineered in Rust for lightning-fast real-time messaging directly inside your terminal emulator.
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', height: 'fit-content' }}>
                <a
                  className="button-link"
                  href="https://crates.io/crates/bens-chat-cli"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on Crates.io
                </a>
                <a
                  className="button-link button-link--secondary"
                  href="/bens-chat-cli.exe"
                  download
                >
                  Download .exe (Windows)
                </a>
              </div>
            </div>

            <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box', marginTop: '1rem' }}>
              <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
              <span>cargo install bens-chat-cli</span>
            </div>
          </section>

          <div className="two-column-grid">
            <section className="section-card">
              <h3 className="section-title">Installation & Quick Start</h3>
              <p className="page-copy">
                Install globally using Cargo or download the standalone Windows executable:
              </p>
              <div className="terminal-line" style={{ display: 'flex', width: '100%', boxSizing: 'border-box', marginBottom: '1rem' }}>
                <span style={{ color: 'var(--accent)', marginRight: '0.5rem' }}>$</span>
                <span>bens-chat-cli</span>
              </div>
              <ul className="bullet-list">
                <li>Type the name of the chat you want to enter, or use <strong>"n"</strong> to create a new chat room.</li>
                <li>Type your message and hit <strong>Enter</strong> to send.</li>
                <li>Use <strong>/exit</strong> to leave the current room and return to the chat list.</li>
                <li>Use <strong>/update</strong> to manually refresh messages if necessary.</li>
              </ul>
            </section>

            <section className="section-card">
              <h3 className="section-title">Architecture & State Machine</h3>
              <p className="page-copy">
                This terminal client is represented as a formal <strong>Finite State Automaton (FSA)</strong> written in Rust.
              </p>
              <p className="page-copy">
                The primary <code>Window</code> struct manages the current active application state, while the central <code>transition</code> method handles reliable state progression. Specific user-input and networking handlers run predictably depending on active state changes.
              </p>
            </section>
          </div>

          <section className="section-card">
            <h3 className="section-title">Demo & Usage</h3>
            <p className="page-copy">
              Watch the CLI in action: navigating chats, creating new rooms, sending real-time messages, and exiting back to the main menu.
            </p>
            <div className="image-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '1.5rem', background: '#020617', border: '1px solid var(--border)' }}>
              <img
                src={demoGif}
                alt="bens-chat-cli terminal demo"
                style={{ width: '100%', maxWidth: '800px', borderRadius: '12px', boxShadow: '0 12px 24px rgba(0,0,0,0.5)' }}
              />
              <p className="caption">Ben's Chat CLI Live Terminal Demo</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CliChatCratePage;
